import React from 'react';
import Carousel from '../Carousel/Carousel';

const Blog = () => {
    return (
        <div>
            <Carousel></Carousel>
        </div>
    );
};

export default Blog;